import { resolveTreeConfig } from '../tree/tree-config'
import { syncTreeTableData } from '../tree/sync-table-data'
import { hasTreeChildren } from '../tree/flatten-visible'
import type { DataGridTree } from '../types'

export function useTreeExpand($grid: DataGridTree) {
  $grid.toggleTreeExpand = (row) => {
    const config = resolveTreeConfig($grid.options)
    const id = String(row[config.rowField])
    const { expandSet } = $grid.internalData

    if (!hasTreeChildren(row, $grid.internalData.flatSource, config)) {
      return
    }

    if (expandSet.has(id)) {
      expandSet.delete(id)
    } else {
      expandSet.add(id)
    }
    syncTreeTableData($grid)
  }
}
